import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "vr-simulation" }
const _hoisted_2 = { class: "yycj" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content-title" }
const _hoisted_5 = { class: "sljs" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "address-list" }
const _hoisted_8 = { class: "address-text" }

import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'
import { modelTypes } from '@/config';
import { exampleDatas } from '@/config/index'


export default /*@__PURE__*/_defineComponent({
  __name: 'MetaverseView',
  setup(__props) {

const loadUrl: any = ref({})
const store = useStore()
const router = useRouter()
const casesList: any = ref({})
const loaderGif: any = ref([]);

const toDetail = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
}

onMounted(async () => {
  selectCommonElement({ columnId: 4, appId: 2 }).then((res: any) => {
    casesList.value = [...res].filter(e => e.industry == 3).sort((a, b) => (a.sortNum ?? 0) - (b.sortNum ?? 0))[0] || {}
  })

  const fays_bg: any = await asynchronousRetrieval('nfznxr-images/jjfa/fays-bg.png');
  const ddzs: any = await asynchronousRetrieval('webimg/gif/ddzs.gif');
  const yyzzt: any = await asynchronousRetrieval('webimg/gif/yyzzt.gif');
  const jswysg: any = await asynchronousRetrieval('webimg/gif/jswysg.gif');
  const sxcz: any = await asynchronousRetrieval('webimg/gif/sxcz.gif');
  loadUrl.value = { fays_bg }
  loaderGif.value.push(ddzs, yyzzt, jswysg, sxcz);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title-text" }, "应用场景", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelTypes)['metaverse'], (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.header
        }, [
          _createElementVNode("img", {
            src: item.image,
            alt: ""
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, _toDisplayString(item.header), 1)
        ]))
      }), 128))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title-text" }, "实例介绍", -1)),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(exampleDatas).yyzzt.example, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("img", {
            src: loaderGif.value[index]
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.address), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})